import React from 'react';
import { UI_ATTR } from './anchor';
import { useComments } from './useCommentsState';

export function FloatingButton() {
  const { mode, toggleOnOff, drawerOpen, setDrawerOpen, openThreadsCurrentRoute } = useComments();
  const on = mode !== 'off';

  return (
    <div className={'bc-fab' + (on ? ' bc-fab--on' : '')} {...{ [UI_ATTR]: '' }}>
      <button
        type="button"
        className="bc-fab__toggle"
        onClick={toggleOnOff}
        title={on ? 'Comentários: ligado (clique p/ desligar)' : 'Comentários: desligado'}
        aria-label="Alternar comentários"
      >
        <svg className="bc-fab__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M21 11.5a8.38 8.38 0 0 1-8.5 8.4 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8A8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {on && openThreadsCurrentRoute > 0 && (
          <span className="bc-fab__count">{openThreadsCurrentRoute}</span>
        )}
      </button>

      {on && (
        <button
          type="button"
          className="bc-fab__link"
          onClick={() => setDrawerOpen(!drawerOpen)}
        >
          {drawerOpen ? 'Fechar painel' : 'Abrir painel'}
        </button>
      )}
    </div>
  );
}
